import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import './WorkersList.css';
import { connect } from 'react-redux';
import { HOST } from '../../constants/Fetch'
import Preloader from '../Preloader';
import ErrorMessage from '../ErrorMessage';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadPersonal } from '../../actions/PersonalActions';

const WorkerItem = props => (
    <Link relative="path" to={`../workers/worker${props.worker.id}`} className={`workersList__item col ${props.col ? 'col--' + props.col : ''}`}>
      <img className="workersList__itemPhoto" src={HOST + props.worker.image_crop} alt={`${props.worker.first_name} ${props.worker.last_name}`} />
      <div className="workersList__itemInfo">
        <div className="workersList__itemName">{props.worker.first_name} {props.worker.last_name}</div>
        {
          props.worker.internship_period &&
          <div className="workersList__itemPosition">{props.worker.internship_period}</div>
        }
        {
          props.worker.text_vacancy &&
          <div className="workersList__itemPosition">{props.worker.text_vacancy}</div>
        }
        {
          props.worker.quote &&
          <div className="workersList__speechWrapper">
            <div className="workersList__itemSpeech" dangerouslySetInnerHTML={{ __html: props.worker.quote}} />
          </div>
        }
      </div>
    </Link>
);

class WorkersList extends Component {
  static requestData(store) {
    return requestAll([loadPersonal], store);
  }

  componentDidMount() {
    this.props.actions.loadPersonal();
  }
  render() {
    let workersList = [];
    if (this.props.popular) {
      workersList = this.props.personal.filter((worker) => {
        return worker.is_main_page;
      });
    } else {
      workersList = this.props.personal
    }

    if (this.props.isLoading) {
      return <Preloader/>;
    }
    if ((this.props.hasErrored) || (this.props.personal.length < 1)) {
      return <ErrorMessage/>;
    }
    return (
      <div className="workersList row">
        {
          workersList.map((worker, index) => (
            <WorkerItem key={`workersList__item-${index}`} col={this.props.cols} worker={worker} />
          ))
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      personal: state.personal.list,
      hasErrored: state.personal.hasErrored,
      isLoading: state.personal.isLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadPersonal }, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WorkersList));



// WEBPACK FOOTER //
// ./src/components/WorkersList/index.js